import React, { useEffect } from "react";
import "./Offers_Slider.css";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Common_Title from "../../common_components/common_title/Common_Title";
import { getAllOfferedProduct } from "../../../features/products/productsSlice";
import { useDispatch, useSelector } from "react-redux";
import { getbestOffer } from "../../../features/home/homeSlice";

function Offers_Slider() {
  const data = [
    "/assets/images/home/best_offer/img1.png",
    "/assets/images/home/best_offer/img2.png",
    "/assets/images/home/best_offer/img1.png",
  ];
  const dispatch = useDispatch();
  
  const coupons = useSelector((state) => state?.home?.bestoffer);

  useEffect(() => {
    dispatch(getbestOffer(100));
  }, []);

  console.log(coupons,"couponscoupons")

  return (
    <section className="Offers_Slider">
      <div className="container">
        <div className="title_div">
          <Common_Title title={"Best Offers"} />
        </div>

        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false, // keeps autoplay after swipe
          }}
          modules={[Pagination, Autoplay]}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            600: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 2.1,
            },
            1400: {
              slidesPerView: 2.5,
            },
          }}
        >
          {coupons?.length > 0 &&
            coupons?.map((item) => {
              return (
                <SwiperSlide>
                  <div className="img_holder">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.image}
                      className="image"
                    />

                    <div
                      style={{
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        background:
                          "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                        color: "#fff",
                        padding: "10px",
                        fontSize: "18px",
                      }}
                    >
                      <div style={{ fontWeight: "700" }}>
                        {/* {item?.name} */}
                      </div>

                      {/* <div>Discount: {item?.discount}</div> */}
                      <div style={{ fontSize: "16px" }}>{item?.message}</div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </section>
  );
}

export default Offers_Slider;
